import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';

@Component({
  selector: "app-configuracion-formulario-formulario",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tab = 1;

  form_formularios_secciones = {
    id: [""],
    formularios_id: [""],
    formularios_secciones_id: [""],
    icono: [""],
    nombre: ["", [Validators.required]],
    orden: ["", [Validators.required]],
    orientacion: ["", [Validators.required]],
    imprimir_nombre: [1, [Validators.required]],
    imprimir_en_comprobante: [1, [Validators.required]],
    formularios_secciones_campos: this.fb.array([])
  };

  form_formularios_secciones_campos = {
    id: [""],
    formularios_secciones_id: [""],
    formularios_secciones_campos_catalogos_id: [""],
    orden: ["", [Validators.required]],
    campo: ["", [Validators.required]],
    tipo_dato: ["", [Validators.required]],
    longitud: [15, [Validators.required]],
    clase: ["is-4", [Validators.required]],
    requerido: [1, [Validators.required]],
    es_catalogo: [0, [Validators.required]],
    es_dependiente: [0, [Validators.required]],
    campo_depende: [''],
    imprimir_en_comprobante: [1, [Validators.required]],
    descripcion: ["", [Validators.required]]
  };

  tipos_datos = [
    { id: "text", text: "Texto" },
    { id: "textarea", text: "Area de Texto" },
    { id: "number", text: "Numero" },
    { id: "email", text: "Correo" },
    { id: "url", text: "Url" },
    { id: "file", text: "File" },
    { id: "phone", text: "Telefono" },
    { id: "date", text: "Fecha" },
    { id: "time", text: "Hora" },
    { id: "select", text: "Lista de selección" },
    { id: "radio", text: "Radio" },
    { id: "checkbox", text: "Check" }

  ];

  orientaciones = [
    { id: "text", text: "VERTICAL" },
    { id: "landscape", text: "HORIZONTAL" }
  ];
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""],
      nombre: ["", [Validators.required]],
      formularios_secciones: this.fb.array([])
    });

    document.getElementById("catalogos").click();
  }

  agregar_form_array_seccion() {
    this.dato.controls.formularios_secciones["controls"].push(this.fb.group({
      id: [""],
      formularios_id: [""],
      formularios_secciones_id: [""],
      icono: [""],
      nombre: ["", [Validators.required]],
      orden: ["", [Validators.required]],
      orientacion: ["", [Validators.required]],
      imprimir_nombre: [1, [Validators.required]],
      imprimir_en_comprobante: [1, [Validators.required]],
      formularios_secciones_campos: this.fb.array([])
    }));
  }

  agregar_form_array_campo(i: number) {
    const model = <FormArray>this.dato.controls.formularios_secciones;
    const seccion = <FormArray>model.controls[i];
    const campo = <FormArray>seccion.controls["formularios_secciones_campos"];
    campo.controls.push(this.fb.group({
      id: [""],
      formularios_secciones_id: [""],
      formularios_secciones_campos_catalogos_id: [""],
      orden: ["", [Validators.required]],
      campo: ["", [Validators.required]],
      tipo_dato: ["", [Validators.required]],
      longitud: [15, [Validators.required]],
      clase: ["is-4", [Validators.required]],
      requerido: [1, [Validators.required]],
      es_catalogo: [0, [Validators.required]],
      es_dependiente: [0, [Validators.required]],
      campo_depende: [''],
      imprimir_en_comprobante: [1, [Validators.required]],
      descripcion: ["", [Validators.required]]
    }));
  }

  quitar_form_array_seccion(i: number) {
    const model = <FormArray>this.dato.controls.formularios_secciones;
    model.removeAt(i);
  }

  quitar_form_array_campo(i: number, c: number) {
    const model = <FormArray>this.dato.controls.formularios_secciones;
    const seccion = <FormArray>model.controls[i];
    const campo = <FormArray>seccion.controls["formularios_secciones_campos"];
    campo.removeAt(c);
  }
}
